import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash-es';

import { emptyObject } from 'ui-components/default-props/empty';
import { SimpleDropdown } from '../../../components/simple-dropdown';
import { BulkActions } from '../../../enums/bulk-actions';
import { CustomsContentValues } from '../../../enums/customs-content';
import { CustomsNonDelivery } from '../../../enums/customs-non-delivery';
import { messages } from './messages';
import style from './bulk-actions.module.css';

export const CustomsDeclarations = {
  id: BulkActions.customsDeclarations.name,

  render: (onChange, model) => {
    const shippingConfiguration = get(model, 'shippingConfiguration', emptyObject);
    const customs = get(shippingConfiguration, 'customs', emptyObject);
    const { content, nonDelivery } = customs;

    return (
      <div className={style['dropdown-list']}>
        <SimpleDropdown
          defaultTitle={<FormattedMessage {...messages.selectContentType} />}
          dropdownMenuShouldHaveWidthOfButton
          items={CustomsContentValues.map((contentType) => ({
            key: contentType.name,
            name: <FormattedMessage {...contentType.translation} />,
          }))}
          label={<FormattedMessage {...messages.customContentType} />}
          onItemSelected={(contentType) => {
            onChange({
              ...model,
              shippingConfiguration: {
                ...shippingConfiguration,
                customs: {
                  ...customs,
                  content: contentType,
                },
              },
            });
          }}
          selectedItemKey={content}
        />
        <SimpleDropdown
          defaultTitle={<FormattedMessage {...messages.selectNonDelivery} />}
          dropdownMenuShouldHaveWidthOfButton
          items={Object.values(CustomsNonDelivery).map((nonDeliveryValue) => ({
            key: nonDeliveryValue.name,
            name: <FormattedMessage {...nonDeliveryValue.translation} />,
          }))}
          label={<FormattedMessage {...messages.ifNonDelivery} />}
          onItemSelected={(nonDeliveryValue) => {
            onChange({
              ...model,
              shippingConfiguration: {
                ...shippingConfiguration,
                customs: {
                  ...customs,
                  nonDelivery: nonDeliveryValue,
                },
              },
            });
          }}
          selectedItemKey={nonDelivery}
        />
      </div>
    );
  },
};
